module.exports = __webpack_public_path__ + "cc4088f7.svg";